// extracted by mini-css-extract-plugin
export default {"container":"style_container__JOaIY","icon":"style_icon__KUAjO","title":"style_title__Dkkf5","textContainer":"style_textContainer__eVjo-"};